import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Header } from "../Header/Header";
import styles from "./SignupPending.module.css";

export const OnboardingWelcome = () => {
  const history = useHistory();

  useEffect(() => {
    const t = setTimeout(() => history.push("/login"), 2600);
    return () => clearTimeout(t);
  }, [history]);

  return (
    <div className={styles.wrapper}>
      <Header />
      <div className={styles.cardContainer}>
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <span className={styles.icon}>✓</span>
          </div>
          <h1 className={styles.title}>Welcome aboard.</h1>
          <p className={styles.description}>
            Your workspace is ready. We're taking you in…
          </p>
          <p className={styles.small}>
            If you aren't redirected, <a href="/login">log in here</a>.
          </p>
        </div>
      </div>
    </div>
  );
};